import { render } from "./PopupComponent.vue?vue&type=template&id=986e84b2&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"

import "./PopupComponent.vue?vue&type=style&index=0&id=986e84b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986e84b2"]])

export default __exports__